import {
  CREATE_COMPLAINT_SUCCESS,
  FETCH_COMPLAINT_SUCCESS,
  FETCH_UNSERVIECABLE_REPORT_SUCCESS,
  GET_COMPLAINT_SUCCESS,
  GET_OPEN_COUNT_START,
  GET_OPEN_COUNT_SUCCESS,
  GET_US_ASSET_COUNT_START,
  GET_US_ASSET_COUNT_SUCCESS,
  SAVE_COMPLAINT_QUERY,
  SAVE_COMPLAINT_REPORT_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  reportTotal: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  reportQuery: {},
  report: [],
  usAssetCount: 0,
  usActiveCount: 0,
  usAssetLeaseCount: 0,
  usAssetCountData: [],
  usAssetCountLoading: false,
  openCount: 0,
  openWithoutJobCount: 0,
  openCountLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_COMPLAINT_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case SAVE_COMPLAINT_REPORT_QUERY: {
      return {
        ...state,
        reportQuery: action.query,
      }
    }

    case GET_COMPLAINT_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_COMPLAINT_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_COMPLAINT_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_UNSERVIECABLE_REPORT_SUCCESS: {
      const query = {...state.reportQuery};
      query.pagination.total = action.data.count;
      return {
        ...state,
        report: action.data.data,
        reportQuery: query,
        reportTotal: action.data.count,
      }
    }
    case GET_US_ASSET_COUNT_SUCCESS: {
      return {
        ...state,
        usAssetCount: action.count,
        usActiveCount: action.activeCount,
        usAssetLeaseCount: action.leaseCount,
        usAssetCountData: action.data,
        usAssetCountLoading: false
      }
    }
    case GET_US_ASSET_COUNT_START: {
      return {
        ...state,
        usAssetCountLoading: true
      };
    }
    case GET_OPEN_COUNT_SUCCESS: {
      return {
        ...state,
        openCount: action.openCount,
        openWithoutJobCount: action.openWithoutJobCount,
        openCountLoading: false
      }
    }
    case GET_OPEN_COUNT_START: {
      return {
        ...state,
        openCountLoading: true
      };
    }
    default:
      return state;
  }
}
